import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';
import { DashboardMsg, GenericResponse } from 'src/app/entities/various';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ConfigProps,ConfigServiceService } from 'src/app/services/config-service/config-service.service';
import { UserService } from 'src/app/services/users/user.service';
import { HttpParams } from '@angular/common/http';



@Component({
  selector: 'app-conf-dashboard',
  templateUrl: './conf-dashboard.component.html',
  styleUrls: ['./conf-dashboard.component.css']
})
export class ConfDashboardComponent implements OnInit {

  dashResponse : GenericResponse | undefined;
  msgList : DashboardMsg[] = [];
  me : UserInfo | undefined;
  @Input() userId : string | number | undefined;
  modifyMsgId: string | number | undefined;
  modifyItem : DashboardMsg = {attivo: 0, messaggio: ''}
  innerWidth: number | undefined;
  params : HttpParams | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  configProps : ConfigProps | undefined;

  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: 'auto',
      minHeight: '400px',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      sanitize: false,
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
      customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      }
    ]
};


  constructor(private loginService : LoginService, private configService : ConfigurationService, private translate : TranslateService,
    private modalService : ModalServiceService, private toastService: ToastService,private confService: ConfigServiceService,private userService: UserService) { }

  async ngOnInit() {
    this.me = JSON.parse(localStorage.getItem("einvuser") || "");
    this.dashResponse= await this.configService.getDashboard(this.userId!);
    this.msgList= this.dashResponse.data;
    this.modifyItem.user_id= this.me!.dms_user_id;
    this.innerWidth = window.innerWidth;
    this.configProps = new UTILS().deepCopy(await this.confService.getJSON());
  }

 

  async openModalRivenditori() {
    let response : undefined | any = await this.modalService.searchRivenditori(this.me!.dms_user_id);
    if(response != null)
        this.modifyItem.rivenditore=response;
  }

  addMsg() {
    this.modifyMsgId = 'new';
    this.modifyItem = {attivo: 0, messaggio: '', id: 'new', user_id:this.me!.dms_user_id,tipo:'public',rivenditore:''};
  }

 
  modifyMsg(msg: DashboardMsg) {
    this.modifyMsgId = msg.id;
    this.modifyItem = new UTILS().deepCopy(msg);
    this.modifyItem.id_dashboard = msg.id;
    this.modifyItem.id=undefined;
    this.modifyItem.user_id= this.me?.dms_user_id;
    this.modifyItem.tipo=msg.tipo;
    this.modifyItem.rivenditore=msg.rivenditore;
  }


  public getTypeName(type :string | undefined,index :number){
    for(var i =0; i< this.configProps!.tipoNotificaDashboard.length; i++){
        if(this.configProps!.tipoNotificaDashboard[i].val==type){
            if(type=="private")
                return this.configProps!.tipoNotificaDashboard[i].label+' <br><b> '+this.msgList[index].rivenditore+'</b>';
            return this.configProps!.tipoNotificaDashboard[i].label;
        }
    }
    return "";
  }

  restoreRivenditore(){
    if(this.modifyItem.tipo!='private')
        this.modifyItem.rivenditore='';
  }

  async save(msgId : string | number) {
    if(this.modifyItem.tipo=='private' && this.modifyItem.rivenditore==''){
          this.toastService.openToast("Seleziona un rivenditore","warning");
          return;
    }

    let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.save");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.save");
    let check = await this.modalService.openConfirm(label, message);
    if(check) {
      let response : GenericResponse;
      if(this.modifyMsgId=='new') {
        this.modifyItem.id='';
        response = await this.configService.saveNewDashboardMsg(this.userId!, this.modifyItem)

      }else {
        response = await this.configService.saveDashboardMsg(this.userId!, this.modifyItem);
      }
      if(response.success) {
        this.toastService.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.save.success"),"success");
      } else {
        this.toastService.openToast(response.msg,"warning");
      }
      this.refresh();
    }
  }

  async deleteMsg(msg: DashboardMsg) {
    if(msg.id=='new') {
      this.modifyMsgId=undefined;
    } else {
      let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.delete");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.delete");
    let check = await this.modalService.openConfirm(label, message);
   
    if(check) {
      let response = await this.configService.deleteDashboardMsg(this.userId!, msg.id!);
      if(response.success) {
        this.toastService.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.delete.success"),"success");
      } else {
        this.toastService.openToast(response.msg,"warning");
      }
      this.refresh();
    }
    }
    
   
  }

  undo() {
    this.modifyMsgId=undefined;
  }

  async refresh() {
    this.dashResponse= await this.configService.getDashboard(this.userId!);
    this.msgList= this.dashResponse.data;
    this.modifyItem= {attivo: 0, messaggio: '', user_id: this.me!.dms_user_id};
    this.modifyMsgId=undefined;
  }

}

